<block-ui>
  <router-outlet></router-outlet>

  <ng-container *ngIf="isDownloadPopup">
    <div class="popup-wrapper position-absolute d-flex flex-row-reverse">
      <div class="popup-multi-download d-flex align-items-center">
        <ng-container *ngIf="isEmployeeDownload">
          <span class="popup-title">
            {{'download_popup.prefixTitle' | translate}}
            bộ hồ sơ của người lao động
            <span class="cl-3f97d9 ml-1">{{employeeName}}</span>
          </span>
        </ng-container>
        <ng-container *ngIf="isLaborContractDownload">
          <span class="popup-title">
            {{'download_popup.prefixTitle' | translate}}
            bộ hồ sơ
            <span class="cl-3f97d9 ml-1">{{laborContractName}}</span>
        </span>
        </ng-container>
        <ng-container *ngIf="!isEmployeeDownload && !isLaborContractDownload">
          <span class="popup-title">
            {{'download_popup.prefixTitle' | translate}}
            <span class="cl-3f97d9 mx-1">{{downloadIds.length}}</span>
            {{'download_popup.suffixTitle' | translate}}
            <span class="cl-3f97d9 ml-1">{{nameMenu | translate}}</span>
          </span>
        </ng-container>
        <mat-spinner mode="indeterminate" class="loading" [diameter]="20" [strokeWidth]="2"></mat-spinner>
        <span class="close-download" (click)="handleCloseDownload()">
          <mat-icon>close</mat-icon>
        </span>
      </div>
    </div>
  </ng-container>
</block-ui>